import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInventories, saveInventory } from '../../../ReduxSlices/Inventories/inventorySlice';
import LoadingDots from '../../shared/LoadingDots';

const AdminInventoryPriceManager = () => {
  const dispatch = useDispatch();
  const { inventories, loading, submitting, error } = useSelector((state) => state.inventories);

  const [editingId, setEditingId] = useState(null);
  const [newPrice, setNewPrice] = useState('');

  //  Fetch initial data
  useEffect(() => {
    if (inventories.length === 0) {
      dispatch(fetchInventories());
    }
  }, [dispatch, inventories.length]);


  //  Begin editing
  const handleEditClick = (id, currentPrice) => {
    setEditingId(id);
    setNewPrice(currentPrice || '');
  };

  //  Save new price
  const handleUpdatePrice = () => {
    if (!newPrice || isNaN(newPrice)) {
      alert('Please enter a valid price');
      return;
    }

    dispatch(
      saveInventory({
        inventory: { unit_price: parseFloat(newPrice) },
        id: editingId,
      })
    )
      .unwrap()
      .then(() => {
        setEditingId(null);
        setNewPrice('');
      })
      .catch((err) => {
        alert(`Error updating price: ${err}`);
      });
  };

  return (
    <div className="p-6 m-[2rem]">
      <h2 className="text-xl font-semibold mb-4">Inventory Price Management</h2>

      {error && <p className="text-red-600 mb-2">Error: {error}</p>}

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-4 py-2 text-left">Code</th>
            <th className="border px-4 py-2 text-left">Name</th>
            <th className="border px-4 py-2 text-left">Batch</th>
            <th className="border px-4 py-2 text-left">Quantity</th>
            <th className="border px-4 py-2 text-right">Unit Price (KSh)</th>
            <th className="border px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="6" className="text-center p-4">
                <LoadingDots height={10} width={30} color="#38AD3E" />
              </td>
            </tr>
          ) 
             : inventories.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center p-4">
                No inventory data available.
              </td>
            </tr>
          ) : (
            inventories.map((inv) => (
              <tr key={inv.id} className="lighten">
                <td className="border px-4 py-2">{inv.medication_code}</td>
                <td className="border px-4 py-2">{inv.name}</td>
                <td className="border px-4 py-2">{inv.batch_number}</td>
                <td className="border px-4 py-2">{inv.quantity}</td>
                <td className="border px-4 py-2 text-right">
                  {editingId === inv.id ? (
                    <input
                      type="number"
                      value={newPrice}
                      step="0.01"
                      onChange={(e) => setNewPrice(e.target.value)}
                       onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleUpdatePrice();
                          } else if (e.key === 'Escape') {
                            setEditingId(null);
                            setNewPrice('');
                          }
                        }}
                      className="border p-1 rounded w-24"
                      autoFocus
                      disabled={submitting}
                    />
                  ) : (
                    `KSh ${Number(inv.unit_price || 0).toFixed(2)}`
                  )}
                </td>
                <td className="border px-4 py-2 flex justify-center item-center ">
                  {editingId === inv.id ? (
                    <div className="flex justify-center gap-[10px]">
                      <button
                        onClick={handleUpdatePrice}
                        disabled={submitting}
                        className={`px-3 py-1 flex gap-[5px] rounded text-white justify-center items-center ${
                          submitting ? 'secondary cursor-not-allowed' : 'primary'
                        }`}
                      >
                        {submitting ? 'Saving...' : 'Save'}
                      </button>
                      <button
                        onClick={() => {
                          setEditingId(null);
                          setNewPrice('');
                        }}
                        disabled={submitting}
                        className="secondary"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => handleEditClick(inv.id, inv.unit_price)}
                      disabled={loading || submitting}
                      className="primary wide"
                    >
                      Set / Update Price
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminInventoryPriceManager;
